<template>
  <div>
    <v-app-bar :color="darkMode?'grey darken-2':'background'" app flat>
      <v-app-bar-nav-icon
        :color="darkMode?'white':'primary'"
        @click.stop="$store.commit('main/lToggle')"
        v-show="isShow"
      ></v-app-bar-nav-icon>
      <div :class="darkMode?'white--text':'primary--text'">{{moduleName | toTitleCase}}</div>
      <v-spacer></v-spacer>
      <!-- <v-chip
        v-if="(instansiTerpilih || totalInstansi>1) && isShow"
        class="ma-2"
        color="#f8f6ff"
        text-color="white"
        @click="pilihInstansi"
        style="cursor:pointer"
      >
        <v-avatar left :size="40" color="white" class="primary">
          <v-icon small>mdi-swap-horizontal</v-icon>
        </v-avatar>
        <p class="caption primary--text mt-4">Sekolah</p>
      </v-chip>-->

      <v-avatar @click.stop="$store.commit('main/rToggle')" background-color="primary">
        <a>
          <v-avatar :size="40" color="white">
            <img v-if="user.image" :src="user.image.url.logo" alt="avatar" />
            <img v-else src="img/avatar-p.png" alt="avatar" />
          </v-avatar>
        </a>
      </v-avatar>
    </v-app-bar>
    <PilihInstansi ref="dlg" />
  </div>
</template>

<script>
import PilihInstansi from "../modules/instansi/components/PilihInstansiDialog";
const lc = window.localStorage;
export default {
  components: {
    PilihInstansi
  },
  data() {
    return {
      sidebar: false,
      avatar: null,
      menu: false,
      // message : 'asdasd',
      // fav : false,
      loading: false,
      items: [
        { to: { name: "home" }, title: "Halaman Depan" },
        { to: { name: "home" }, title: "Perencanaan" },
        { to: { name: "home" }, title: "Implementasi" },
        { to: { name: "home" }, title: "Laporan" }
      ]
    };
  },
  computed: {
    totalInstansi() {
      return this.$store.getters["main/totalInstansi"];
    },
    user() {
      let u = this.$store.getters["user/user"];
      // if(u.file_foto.data==null){
      //   u.file_foto=null
      // }

      // eslint-disable-next-line

      return u ? u : null;
    },
    moduleName() {
      return this.$route.meta && this.$route.meta.module
        ? this.$route.meta.module
        : "";
    },
    isShow() {
      return this.$route.name !== "instansi.pilih";
    },
    instansiTerpilih() {
      let i = this.$store.getters["instansi/instansi_aktif"];
      if (i && i.roleku && i.roleku.id == 3) {
        return false;
      } else {
        return true;
      }
    },
    darkMode() {
      return lc.getItem("DARKMODE") == "true" ? true : false;
    }
  },
  methods: {
    clickDrawer() {
      this.$emit("dclicked");
    },
    pilihInstansi() {
      this.$refs.dlg
        .open()
        .then(res => res)
        .catch(e => e);
    },
    logout() {
      this.loading = true;
      this.$store
        .dispatch("user/logout")
        .then(() => {
          this.menu = false;
          this.loading = false;
          this.$router.push({ name: "login" });
        })
        .catch(() => {
          this.loading = false;
        });
    }
  },
  watch: {
    // hSidebar(n) {
    //   this.sidebar = n;
    // }
  }
};
</script>
